interface InputWrapperProps {
  label?: string;
  description?: string;
  children: React.ReactNode;
  hasError?: boolean;
}

export function InputWrapper({ label, description, children, hasError }: InputWrapperProps) {
  return (
    <div className="flex flex-col gap-y-1 w-full">
      {label && (
        <span
          className={`text-left text-sm ${hasError ? 'text-red-800' : 'text-muted-foreground'}`}
        >
          {label}
        </span>
      )}
      <div
        className={`col-span-3 border ${
          hasError ? 'border-red-800' : 'border-neutral-200'
        } rounded-md p-2 bg-white flex items-center`}
      >
        {children}
      </div>
      {description && (
        <span className="text-left text-xs text-muted-foreground">{description}</span>
      )}
    </div>
  );
}
